"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 导出失败的 Icon
 * url: https://figma-alpha-api.s3.us-west-2.amazonaws.com/images/5d15d999-68b7-4d04-935e-1ef49e6d995f
 * name: MIcFileFillMaxColor
 */
function MIcFileFillMaxColor() {
    return null;
}
exports.default = MIcFileFillMaxColor;
;
